// Spark / CATALOG - листинги: сортировка, Load More (доклейка без перезагрузки).
document.addEventListener( 'DOMContentLoaded', () => {

    // сортировка: value = "order_by:order" -> query по контракту CatalogListing
    const initSort = () => {

        const sort = document.getElementById('sortSelect');

        if( ! sort )
            return;

        // текущее значение: query сильнее, без query - дефолт страницы
        // (data-default селекта; листинги без атрибута - created_at:desc)
        const q   = new URLSearchParams( location.search );
        const cur = q.get('order_by')
            ? q.get('order_by') + ':' + ( q.get('order') || 'desc' )
            : ( sort.dataset.default || 'created_at:desc' );

        if( [...sort.options].some( o => o.value === cur ) )
            sort.value = cur;

        sort.addEventListener( 'change', function() {

            const parts = this.value.split(':');

            q.set( 'order_by', parts[0] );
            q.set( 'order', parts[1] );
            q.delete('page'); // новая сортировка - с первой страницы

            location.search = q.toString();
        } );
    };

    // Load More: тянем следующую страницу тем же URL, выклеиваем из неё
    // карточки в текущую сетку. Кончились страницы (в ответе нет кнопки) -
    // кнопка уходит совсем. Сеть подвела - честный переход по href.
    const initLoadMore = () => {

        const btn = document.getElementById('loadMoreBtn');

        if( ! btn )
            return;

        const grid = btn.closest('section')?.querySelector('.product-row-5');

        if( ! grid )
            return;

        btn.addEventListener( 'click', async ( e ) => {

            e.preventDefault();

            if( btn.classList.contains('is-loading') )
                return;

            btn.classList.add('is-loading');

            try {

                const response = await fetch( btn.href );

                if( ! response.ok )
                    throw new Error( 'HTTP ' + response.status );

                const doc = new DOMParser().parseFromString( await response.text(), 'text/html' );

                // сетку берём от кнопки ответа (та же секция, что у нас);
                // последняя страница без кнопки - первая сетка документа
                const nextBtn  = doc.getElementById('loadMoreBtn');
                const nextGrid = nextBtn
                    ? nextBtn.closest('section')?.querySelector('.product-row-5')
                    : doc.querySelector('.product-row-5');

                if( nextGrid )
                    grid.append( ...nextGrid.children );

                if( nextBtn )
                    btn.href = nextBtn.href;
                else
                    btn.closest('.load-more-wrap').remove();

            } catch( err ) {

                // сеть/парсинг подвели - не зависаем, уходим переходом
                location.href = btn.href;

            } finally {
                btn.classList.remove('is-loading');
            }
        } );
    };

    initSort();
    initLoadMore();
} );